import React from 'react';
import ErrorBoundary from './components/common/ErrorBoundary';
import InsightsAgentPrototype from './InsightsAgentPrototype';

function App() {
  return (
    <ErrorBoundary>
      <InsightsAgentPrototype />
    </ErrorBoundary>
  );
}

export default App;
